interface ApiConfig {
  v2ApiBase: string;
}

export const useApiBase = (): ApiConfig => {

  return {
    v2ApiBase: import.meta.env.VITE_PUBLIC_V2_API_BASE
  }

  // const nuxtApp = useNuxtApp()
  // const config = useRuntimeConfig()
  // if (!cachedConfig) {
  //   const nuxtApp = useNuxtApp()
  //   const config = useRuntimeConfig()
  //   cachedConfig = {
  //     v2ApiBase: config.public.v2ApiBase
  //   }
  // }
  
  // return cachedConfig as ApiConfig
}

// Non-composable version for utility functions
export const getApiBase = () => {
  return useApiBase().v2ApiBase
}
